export enum EmployeeReviewStatus {
    notStarted = 1,
    draft = 2,
    submitted = 3,
    complete = 4,
    deleted = 5,
}
